import { render, staticRenderFns } from "./live-quiz.vue?vue&type=template&id=12b3143a&scoped=true&"
import script from "./live-quiz.vue?vue&type=script&lang=js&"
export * from "./live-quiz.vue?vue&type=script&lang=js&"
import style0 from "./live-quiz.vue?vue&type=style&index=0&id=12b3143a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3143a",
  null
  
)

export default component.exports